<ia-report-technical-problem-panel [title]="'screens.description.panel.header.title' | translate">
  @if (context.isMbGroup) {
    <h3 class="tw-text-lg tw-font-bold">
      {{ 'screens.description.panel.content.title' | translate }}
    </h3>
  }
  <form class="mb-group:tw-space-y-7.5 hb-group:tw-space-y-6 sm:tw-w-1/2">
    <div class="mb-group:tw-space-y-2.5 hb-group:tw-space-y-1">
      <label
        for="theme"
        class="tw-cursor-pointer hbpro:tw-text-sm hbpro:tw-text-payne-gray nhb:tw-text-cerulean mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
      >
        {{ 'screens.description.panel.content.form.select.label' | translate }}
      </label>
      <ia-listbox2
        [formField]="form.theme"
        [placeholder]="'screens.description.panel.content.form.select.placeholder' | translate"
        triggerId="theme"
        [style]="context.isNhb ? '--ia-listbox__trigger-icon__color: #044258' : ''"
      >
        @for (
          option of 'screens.description.panel.content.form.select.options' | translate;
          track $index
        ) {
          <ia-listbox2-option
            [value]="option"
            class="hb-group:[&_.ia-selection-check-mark]:tw-hidden"
          >
            {{ option }}
          </ia-listbox2-option>
        }
      </ia-listbox2>
    </div>
    <div>
      <label
        for="description"
        class="tw-cursor-pointer hbpro:tw-text-sm hbpro:tw-text-payne-gray nhb:tw-text-cerulean mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
      >
        {{ 'screens.description.panel.content.form.textarea.label' | translate }}
      </label>
      <textarea
        [formField]="form.description"
        data-test-id="description"
        id="description"
        rows="9"
        [placeholder]="'screens.description.panel.content.form.textarea.placeholder' | translate"
        class="tw-mt-2 tw-w-full tw-resize-none tw-border tw-bg-white tw-px-4 hbpro:tw-px-4 hbpro:tw-py-6 hbpro:tw-text-base hbpro:tw-text-midnight-green nhb:tw-py-3 nhb:tw-text-hb-base mb-group:tw-rounded mb-group:tw-border-geyser mb-group:tw-py-2 mb-group:tw-shadow-inner hb-group:tw-rounded-xl hb-group:tw-border-regent-gray hb-group:placeholder:tw-text-slate-gray-2"
      ></textarea>
      <p
        class="tw-text-right mb-group:tw-text-sm mb-group:tw-text-armoury hb-group:tw-text-hb-sm hb-group:tw-text-slate-gray-2"
      >
        {{
          'screens.description.panel.content.form.textarea.hint'
            | translate: { remainingCharacters: remainingCharacters() }
        }}
      </p>
    </div>
    <div class="tw-flex tw-flex-col">
      <label
        for="attachment"
        class="tw-mb-1 tw-cursor-pointer hbpro:tw-text-sm hbpro:tw-text-payne-gray nhb:tw-text-cerulean mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
      >
        {{ 'screens.description.panel.content.form.attachment.label' | translate }}
      </label>
      <div class="tw-text-sm tw-text-nevada hbpro:tw-text-hb-sm hbpro:tw-text-payne-gray">
        <p id="attachment-help">
          {{ 'screens.description.panel.content.form.attachment.help' | translate }}
        </p>
        <p id="attachment-meta" class="tw-flex tw-flex-col">
          <span>
            {{ 'screens.description.panel.content.form.attachment.meta.format' | translate }}
          </span>
          <span>
            {{ 'screens.description.panel.content.form.attachment.meta.maxSize' | translate }}
          </span>
          <span>
            {{
              'screens.description.panel.content.form.attachment.meta.maxCount'
                | translate: { maxCount: maxAttachments() }
            }}
          </span>
        </p>
      </div>
      <input
        #attachmentInput
        id="attachment"
        type="file"
        multiple
        accept=".png, .jpg, .jpeg, .pdf"
        aria-describedby="attachment-help attachment-meta"
        data-test-id="attachments"
        class="tw-sr-only"
        tabindex="-1"
        [disabled]="!canAddMoreAttachment()"
        (change)="onAttachmentsSelected($event)"
      />

      @for (error of form.attachments().errors(); track error.kind) {
        <ia-report-technical-problem-field-error
          [show]="true"
          [message]="error.message | translate"
        />
      }

      <button
        iaButton
        type="button"
        [variant]="context.isMbGroup ? 'primary' : 'secondary'"
        [outline]="context.isMbGroup"
        [size]="context.isMbGroup ? 'large' : 'standard'"
        [disabled]="!canAddMoreAttachment()"
        (click)="attachmentInput.click()"
        data-test-id="add-attachment"
        class="tw-mt-4 tw-w-fit hbpro:tw-px-6 hbpro:tw-py-4 hbpro:tw-font-hello-type-next mb-group:tw-text-base mb-group:tw-font-semibold nhb:[&:not(:hover)]:tw-bg-[#f4f5f6]"
      >
        {{ 'screens.description.panel.content.form.attachment.input.label' | translate }}
      </button>

      @if (store.description().attachments.length) {
        <ul class="tw-mt-5 mb-group:tw-space-y-4 hb-group:tw-space-y-2">
          @for (attachment of store.description().attachments; track attachment.name) {
            <li ia-report-technical-problem-attachment [file]="attachment"></li>
          }
        </ul>
      }
    </div>
  </form>
</ia-report-technical-problem-panel>
<button
  iaButton
  data-test-id="btn-details-next"
  type="button"
  variant="primary"
  [size]="context.isMbGroup ? 'large' : 'standard'"
  class="tw-self-center hbpro:tw-px-6 hbpro:tw-py-4 hbpro:tw-font-hello-type-next mb-group:tw-text-base mb-group:tw-font-semibold max-sm:tw-w-fit sm:tw-self-end"
  [disabled]="!valid()"
  (click)="onContinue()"
>
  {{ 'common.button.next' | translate }}
</button>
